import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["aria-label"];
import { inject, onMounted, ref } from "vue";
import { WordEditAdvance } from "@/types/transcript";
// Setup
export default /*@__PURE__*/ _defineComponent({
    __name: 'WordInlineEditor',
    props: {
        text: {},
        wordIndex: {},
        selectOnMount: { type: Boolean }
    },
    emits: ["commit", "cancel"],
    setup(__props, { emit: __emit }) {
        // Inline editor for a single transcript word. The parent mounts this in
        // place of the word's <span> on double-click / E-key. Enter, Tab, and blur
        // all commit; Escape cancels. The session-scoped Undo toast is the safety
        // net for accidental blur- or Tab-commits.
        const props = __props;
        const emit = __emit;
        const i18n = inject("i18n");
        const value = ref(props.text);
        const inputEl = ref();
        const committed = ref(false);
        onMounted(() => {
            const el = inputEl.value;
            if (!el)
                return;
            el.focus();
            // Double-click means replace-the-word, so select it; the keyboard paths keep the caret at the end to append.
            if (props.selectOnMount) {
                el.select();
            }
            else {
                el.setSelectionRange(el.value.length, el.value.length);
            }
        });
        const tokenise = (s) => {
            const trimmed = s.trim();
            if (trimmed === "")
                return [];
            return trimmed.split(/\s+/);
        };
        const commit = (advance) => {
            if (committed.value)
                return;
            committed.value = true;
            const tokens = tokenise(value.value);
            // Compare against the prop's tokenisation so trailing whitespace and
            // multi-space typing don't register as a real change.
            const unchanged = tokens.join(" ") === tokenise(props.text).join(" ");
            emit("commit", { wordIndex: props.wordIndex, tokens, advance, unchanged });
        };
        const onEnter = (e) => {
            if (e.isComposing)
                return;
            e.preventDefault();
            commit(WordEditAdvance.Stop);
        };
        const onEscape = (e) => {
            e.preventDefault();
            if (committed.value)
                return;
            committed.value = true;
            emit("cancel");
        };
        const onTab = (e) => {
            e.preventDefault();
            if (committed.value)
                return;
            commit(e.shiftKey ? WordEditAdvance.Backward : WordEditAdvance.Forward);
        };
        const onBlur = () => {
            if (committed.value)
                return;
            commit(WordEditAdvance.Stop);
        };
        return (_ctx, _cache) => {
            return _withDirectives((_openBlock(), _createElementBlock("input", {
                ref_key: "inputEl",
                ref: inputEl,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((value).value = $event)),
                type: "text",
                class: "word-inline-editor",
                "aria-label": _unref(i18n).t('Edit word'),
                onKeydown: [
                    _withKeys(onEnter, ["enter"]),
                    _withKeys(onEscape, ["esc"]),
                    _withKeys(onTab, ["tab"])
                ],
                onBlur: onBlur
            }, null, 40, _hoisted_1)), [
                [_vModelText, value.value]
            ]);
        };
    }
});
